export const incomingRequests = {

  "title": "Matching inteligente",
  "subtitle": "Descubre miembros que quieren visitar tu región",
  "requests": {
    "title": "Solicitudes",
    "count": "{{count}} solicitud(es)",
    "empty": {
      "noListingDescription": "Aún no tienes un anuncio. Publica uno para recibir solicitudes."
    },
    "loading": "Cargando solicitudes...",
    "errors": {
      "notAuthenticated": "Debes iniciar sesión para ver esta página.",
      "loadFailed": "Ocurrió un error al cargar las solicitudes."
    },
    "defaultPropertyType": "Alojamiento",
    "sortOptions": {
      "recent": "Más reciente",
      "rating": "Mejor valorado",
      "distance": "Íntimamente"
    }
  },
  "aiSection": {
    "title": "Sugerencias inteligentes",
    "subtitle": "Descubre los miembros que coinciden con tus criterios",
    "distance": "Distancia",
    "dates": "Fechas",
    "guests": "Viajeros",
    "matchScore": "Puntuación de compatibilidad",
    "search": "Buscar",
    "startDiscussion": "Iniciar discusión",
    "viewProfile": "Ver perfil",
    "away": "de distancia"
  }
};
